import { get } from 'lodash';

export function handleApiError(e) {
    console.error(e);
    return {
        error: true,
        message: get(e, 'response.data.error.message') || e.message,
        status: e.response.status,
        code: get(e, 'response.data.error.code') || e.code
    };
}
